export var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => (typeof message === 'string' ? { message } : message || {});
})(errorUtil || (errorUtil = {}));
